import { CUSTOM_LIST_ALGOLIA_COOKIE } from './constants';

const hasCustomListAlgoliaCookie = () => {
  if (typeof document === 'undefined') {
    return false;
  }

  return document.cookie.split('; ').some(part => {
    const separator = part.indexOf('=');
    if (separator === -1) {
      return false;
    }
    const name = part.slice(0, separator);
    const value = part.slice(separator + 1);
    return name === CUSTOM_LIST_ALGOLIA_COOKIE && value === 'true';
  });
};

export default hasCustomListAlgoliaCookie;
